import styled from "styled-components"

interface LabelProps {
  color?: string
}

const LabelStyled = styled.label<LabelProps>`
  color: ${(props) => props.color};
  font-family: -apple-system, system-ui, BlinkMacSystemFont, Arial, sans-serif;
  font-size: 1rem;
  font-weight: 600;
`

export function Label({
  name,
  color,
  label,
}: {
  name: string;
  color?: string;
  label?: string;
}) {
  return (
    <LabelStyled htmlFor={name} color={color}>{label}</LabelStyled>
  )
}
